/* (ignored) */


//////////////////
// WEBPACK FOOTER
// supports-color (ignored)
// module id = 1252
// module chunks = 0